import "./TitleIsland.scss";
function TitleIsland() {
  return (
    <article className="titleIsland">
      <div className="titleIsland__pre-title">What do you want to learn ?</div>
      <div className="titleIsland__title">What We Offer</div>
      <div className="main-title__pre-title">
        <div className="main-pre-title">
          <div className="pre-title__text">I want to learn </div>
          <div className="pre-title__line"></div>
        </div>
      </div>
    </article>
  );
}
export default TitleIsland;
